module.exports = __webpack_public_path__ + "static/media/camsoda.66bd1a1e.png";